/** Summary / offers: mandatory (TPVCA) insurance territory label and DUK article */
export const TPVCA_GREEN_CARD_TERRITORY_LABEL =
  'Europos Sąjungos šalys ir Šveicarija';

export const TPVCA_GREEN_CARD_DUK_URL =
  'https://www.draudykle.lt/duk?kategorija=kur-reikalinga-zalioji-kortele';

const TERRITORY_NO_LINK_PROVIDERS = new Set(['compensa']);

/**
 * @param {string|undefined} provider - API provider code (e.g. compensa, ld, ergo)
 * @returns {{ mode: 'link', href: string, label: string } | { mode: 'text', label: string }}
 */
export function getTpvcGreenCardTerritoryDisplay(provider) {
  const p = (provider ?? '').toLowerCase();
  const label = TPVCA_GREEN_CARD_TERRITORY_LABEL;
  if (TERRITORY_NO_LINK_PROVIDERS.has(p)) {
    return { mode: 'text', label };
  }
  return {
    mode: 'link',
    href: TPVCA_GREEN_CARD_DUK_URL,
    label,
  };
}
